import { type Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "Zenit",
    id: "0b92c10a-d6e7-4da0-bd99-44cfc375408c",
  },
  {
    name: "MatNat-backen",
    id: "dd329c78-c810-4611-bb27-88042b6c6e5b",
  },
  {
    name: "Bokab",
    id: "85982009-31dd-4597-9362-cd1b093b7f17",
  },
  {
    name: "Baljan",
    id: "e9c2c27c-e9c0-473f-ba54-c73dd468e729",
  },
  {
    name: "LiU-store",
    id: "13b0a454-4128-4e6a-9d52-f8ce0b3f24fa",
  },
  {
    name: "LiU-secondhand",
    id: "38389bd8-62e3-4ec1-9860-70b7a10b543c",
  },
  {
    name: "M-verkstan",
    id: "ac63bbe8-4ea7-4847-9a57-66da7e966fc1",
  },
  {
    name: "Campusbokhandeln",
    id: "b9968620-2b3d-44a5-ae59-3858b7c62634",
  },
  {
    name: "Biblioteket",
    id: "e17bf523-259a-4752-9a96-f4dd6d0c7db6",
  },
  {
    name: "Campushallen",
    id: "d5950789-a6f9-4cd6-9cbf-6ec88c94bc52",
  },
  {
    name: "VAL1",
    id: "fd456f2e-d951-4cc5-af88-275469f4182e",
  },
  {
    name: "Lilla Hoben-tältet",
    id: "2a7a9f83-9083-4f05-a6f4-6c8e4bb3ee3e",
  },
  {
    name: "Stora Hoben-tältet",
    id: "4931cb09-2dc1-40c9-91c7-d3f88378e7fe",
  },
  {
    name: "Skogen bakom A-huset",
    id: "2a53ce96-fa0a-4112-b2eb-d325b013a1fd",
  },
  {
    name: "Studenthälsan",
    id: "a27bac3a-c8b6-4f83-9398-a7c97684edd4",
  },
] as Room[];
